import React from 'react';

const SvgPk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PK_svg__b" fill="#fff">
        <use xlinkHref="#PK_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path d="M8 0h20v20H8V0z" fill="#0A632F" mask="url(#PK_svg__b)" />
      <g mask="url(#PK_svg__b)" fill="#FFF">
        <path d="M23.67 10.75a5.577 5.577 0 0 1-1.603 3.395c-2.246 2.246-5.966 2.167-8.31-.176-2.343-2.343-2.422-6.063-.176-8.31a5.577 5.577 0 0 1 3.395-1.603 5.553 5.553 0 0 0-1.107.86c-2.042 2.041-2.143 5.25-.226 7.167 1.917 1.917 5.126 1.816 7.168-.225.34-.34.627-.714.86-1.107zm-2.578-2.645l-.318 1.898-.89-1.707-1.903.284 1.349-1.373-.859-1.723 1.723.858 1.374-1.349-.284 1.904 1.707.89-1.899.318z" />
      </g>
    </g>
  </svg>
);

export default SvgPk;
